export const authInfo ={
    data() {
        return {
            name: {
                val:'',
                isValid:true,
                wordValid:true
            },
            zonecode: {
                val:'',
                isValid:true,
                wordValid:true
            },
            roadAddress: {
                val:'',
                isValid:true,
                wordValid:true
            },
            addressDetail:{
                val:'',
                isValid:true,
                wordValid:true
            },
            phone1:{
                val:'010',
                isValid:true, 
                wordValid:true               
            },
            phone2:{
                val:'',
                isValid:true,
                wordValid:true
            },
            phone3:{
                val:'',
                isValid:true,
                wordValid:true
            },
            email:{
                val:'',
                isValid:true,
                wordValid:true
            },  
            
        }
    },
    mounted(){
        this.authInfo();
    },
    methods:{
        async authInfo() {            
            try {
                const response = await this.$store.dispatch("users/authInfo", {
                    user_id: this.user.id,
                });
                //인증정보
                let authInfo = response.auth;
                if(response.auth !== null)
                {            
                    this.name.val =  authInfo.name;
                    this.phone1.val = authInfo.phone1;
                    this.phone2.val = authInfo.phone2;
                    this.phone3.val = authInfo.phone3;
                    this.zonecode.val = authInfo.zonecode;
                    this.roadAddress.val = authInfo.roadAddress;
                    this.addressDetail.val = authInfo.addressDetail;
                    this.email.val = authInfo.email;      
                }
            
                console.log("인증정보" + authInfo.name);
                //console.log("방정보" + JSON.stringify(response.roomInfo));
                this.chatroom = response.roomInfo;                
            } catch (error) {
                console.log("에러", error.response);
                //에러면 이전페이지로
            }            
        },   
    }  
}